import React, { useRef, useState } from "react";
import { Dialog } from "@headlessui/react";
import Input from "../controls/Input";
import { ArrowRightCircleIcon } from "@heroicons/react/24/outline";

export default function NextInProcessModal(props) {
  const { buttonMessage, confirmAction, message, setOpen, title } = props;
  const cancelButtonRef = useRef(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const submit = (event) => {
    event.preventDefault();
    if (!username.trim() || !password) return;
    confirmAction({ username: username.trim(), password });
  };

  return (
    <form onSubmit={submit}>
      <div>
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-indigo-100">
          <ArrowRightCircleIcon
            className="h-11 w-11 text-indigo-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-base font-normal leading-6 text-gray-800 family-didact"
          >
            {title}
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm font-normal family-didact">{message}</p>
          </div>
        </div>

        <div className="mt-4 flex flex-col items-center gap-3">
          <div className="w-full max-w-xs">
            <label
              htmlFor="in-process-username"
              className="mb-1 block text-center text-sm font-medium text-[#0F172A]"
            >
              Username
            </label>
            <Input
              name="username"
              id="in-process-username"
              onChange={(e) => setUsername(e.target.value)}
              value={username}
              labelOn={false}
              type="text"
              autoComplete="username"
              className="block w-full rounded-md border border-gray-300 px-3 py-35-custom text-center shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            />
          </div>
          <div className="w-full max-w-xs">
            <label
              htmlFor="in-process-password"
              className="mb-1 block text-center text-sm font-medium text-[#0F172A]"
            >
              Password
            </label>
            <Input
              name="password"
              id="in-process-password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              labelOn={false}
              type="password"
              autoComplete="current-password"
              className="block w-full rounded-md border border-gray-300 px-3 py-35-custom text-center shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center sm:grid sm:grid-flow-row-dense sm:grid-cols-2 gap-3">
        <div className="col-span-1 text-right">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
            onClick={() => setOpen({ childComponent: null, open: false })}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-1">
          <button
            type="submit"
            className="inline-flex w-fit justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-light family-didact text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 col-span-1 sm:mt-0"
            ref={cancelButtonRef}
          >
            {buttonMessage}
          </button>
        </div>
      </div>
    </form>
  );
}
